import { useCallback, useRef } from 'react';
function eventToPosition(evt) {
  return [evt.screenX, evt.screenY];
}
export function useTrackedPointer() {
  var lastPos = useRef([-1, -1]);
  var wasPointerMoved = useCallback(function (evt) {
    var newPos = eventToPosition(evt);
    if (lastPos.current[0] === newPos[0] && lastPos.current[1] === newPos[1]) {
      return false;
    }
    lastPos.current = newPos;
    return true;
  }, []);
  var pointerUpdate = useCallback(function (evt) {
    lastPos.current = eventToPosition(evt);
  }, []);
  return {
    pointerUpdate: pointerUpdate,
    wasPointerMoved: wasPointerMoved
  };
}